
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const NavigateAway = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M20,19.2a2.3,2.3,0,0,1-2.3,2.3H7V3.5H20V6.1h1.5V2H5.5V23H17.7a3.8,3.8,0,0,0,3.8-3.8v-.3H20Z"></path>
            <polygon points="18.6 17.9 24 12.5 18.6 7.1 17.5 8.2 21.1 11.7 13.5 11.7 13.5 13.2 21.1 13.2 17.5 16.8 18.6 17.9"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

NavigateAway.defaultProps = {
  title: 'Navigate Away',
};

export default NavigateAway;
